import React from "react";
import SummerSaleBanner from "./SummerSaleBanner";
import { isSummerSaleActive } from "constants/SummerSale";

/**
 * Renders the full-width SummerSaleBanner only while the sale is active.
 * Used to drop the banner at the top of pages (help, articles, login, connect,
 * redeem-code, join) via AppRoutes without each page importing the gate itself.
 */
const SummerSaleBannerSlot = () => (isSummerSaleActive() ? <SummerSaleBanner /> : null);

export default SummerSaleBannerSlot;
